<template>
  <div>
    <default-dialog fullscreen :loading="loading.client">
      <template slot="title">
        Detalhes do Cliente
      </template>
      <template slot="right-title">
        <div :class="['d-flex', $vuetify.breakpoint.smAndup ? 'my-3' : 'mt-1']">
          <v-btn 
            :style="$vuetify.breakpoint.smAndDown ? 'border: solid 1px lightgrey;' : 'border: solid 1px lightgrey; border-style: solid solid none solid;'"
            elevation="0" tile x-large 
            :class="$vuetify.breakpoint.smAndUp ? ['px-10', 'my-n2', 'mb-n3', 'mt-1', 'mx-1', only_client_infos ? 'primary' : 'grey--text'] : [only_client_infos ? 'primary' : 'grey--text']" 
            :x-large="$vuetify.breakpoint.mdAndUp" 
            :small="!$vuetify.breakpoint.smAndUp" 
            :min-width="$vuetify.breakpoint.smAndDown ? '' : '300px'" 
            @click="only_client_infos = !only_client_infos"
            style="margin-bottom: -10px !important;"
          ><v-icon small left>mdi-card-account-details</v-icon> cadastro</v-btn>
          <v-btn 
            :style="$vuetify.breakpoint.smAndDown ? 'border: solid 1px lightgrey;' : 'border: solid 1px lightgrey; border-style: solid solid none solid;'"
            elevation="0" 
            tile 
            :x-large="$vuetify.breakpoint.mdAndUp" 
            :small="!$vuetify.breakpoint.smAndUp" 
            :min-width="$vuetify.breakpoint.smAndDown ? '' : '300px'" 
            :class="$vuetify.breakpoint.smAndUp ? ['px-10', 'my-n2', 'mb-n3', 'mt-1', 'mx-1', !only_client_infos ? 'primary' : 'grey--text'] : [!only_client_infos ? 'primary' : 'grey--text']"  
            @click="only_client_infos = !only_client_infos"
            style="margin-bottom: -10px !important;"
          ><v-icon small left>mdi-currency-usd</v-icon>financeiro</v-btn>
        </div>
      </template>
      <template slot="content" class="pa-n5">
        <v-container v-if="!loading.client && only_client_infos" fluid >

          <v-expansion-panels v-model="panel" multiple flat class="ml-4 mr-15 pr-10" active-class="elevation-2 " popout >

            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-information</v-icon>
                  Informações básicas
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit v-if="user_allowed || isClerk"  small class="ml-2" @click="edit.info = true"></f-btn>
                  </v-card-title>
                  <v-card-text>
                    <client-edit-info-dialog @update="handleUpdate" @close="edit.info = false" :change_dialog="edit.info"></client-edit-info-dialog>
                    <ClientInfoForm :client="client.data.attributes" read_only></ClientInfoForm>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-key</v-icon>
                  Chaves de Acesso
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit v-if="user_allowed"  small class="ml-2" @click="edit.spc_and_keys = true"></f-btn>
                  </v-card-title>
                  <v-card-text>
                    <ClientEditClientCompanyKey @update="handleUpdate" @changeAttachedFile="handleChangeAttachedFile" @close="edit.spc_and_keys = false" :change_dialog="edit.spc_and_keys"></ClientEditClientCompanyKey>
                    <v-row justify="space-between">
                      <v-col cols='12' sm='6' md='4' v-if="user_allowed">
                        <v-text-field :value="client.data.attributes.token" label="Chave de acesso ao sistema" readonly></v-text-field>
                      </v-col>
                      <v-col cols='12' sm='6' md="4" v-if="user_allowed">
                        <v-text-field :value="'https://webcimentao.com.br/client?ctk='+client.data.attributes.token" label="Link de acesso ao sistema" readonly></v-text-field>
                      </v-col>
                      <v-col cols='12' sm='4' v-if="user_allowed">
                        <v-text-field :value="pixCompanyLabel(client.data.attributes.fixed_company_in_pix)" label="Empresa fixa para gerar pix" readonly></v-text-field>
                      </v-col>

                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            
            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-window-shutter</v-icon>
                  Disponibilidade do cliente
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <EditSolutions @update="clearAndGetData" :model_modality_ids="client?.data.attributes.modality_ids"></EditSolutions>
              </v-expansion-panel-content>
            </v-expansion-panel>    

            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-wallet</v-icon>
                  Formas de pagamento padrão
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ClientDefaultPayment></ClientDefaultPayment>
              </v-expansion-panel-content>
            </v-expansion-panel>     

            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-lock</v-icon>
                  Formas de Pagamento e Prazos Permitidos
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ClientAllowedPayments @updated="handleSuccessSaved"></ClientAllowedPayments>
              </v-expansion-panel-content>
            </v-expansion-panel>     

            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold ">
                <div>
                  <v-icon size="19" color="red">mdi-account-multiple</v-icon>
                  Carteira de Clientes
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit small class="ml-2" @click="edit.seller = true"></f-btn>
                  </v-card-title>
                  <v-card-text>
                    <DialogEditClientPortfolio @updated="clearAndGetData" :change_dialog="edit.seller" :model="client?.data?.attributes" @close="edit.seller = false"></DialogEditClientPortfolio>
                    <div v-if="client?.data?.attributes?.client_portfolio_ids?.length == 0">
                      <span class="subtitle-1">
                        <v-icon left>mdi-account-multiple-remove</v-icon>
                        Cliente não cadastrado em nenhuma carteira                            
                      </span>
                    </div>
                    <div v-if="client?.data?.attributes?.client_portfolio_ids?.length > 0">
                      <ChooseClientPortfolioForm readonly :model="client?.data?.attributes"></ChooseClientPortfolioForm>
                    </div>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-map</v-icon>
                  Endereço de faturamento
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row justify="space-around">
                      <v-col cols='12'>
                        <v-card class="pa-1" style="border-radius:8px">
                          <gmap-map 
                            style="width: 100%; height: 400px;" 
                            :zoom="7"
                            :center="{ lat: -20.627893, lng: -45.179926 }" 
                            :options="{
                              zoomControl: true,
                              mapTypeControl: true,
                              scaleControl: false,
                              streetViewControl: false,
                              rotateControl: false,
                              fullscreenControl: false,
                              disableDefaultUi: false
                            }" 
                            ref="map"
                          >
                            <template>
                              <gmap-marker v-for="(marker, index) in client.data?.attributes?.address?.data" :key="index"
                                :position="marker.attributes.coordinates[0]"
                                :title="`${marker.attributes.full_address}`" />
                            </template>
                          </gmap-map>
                        </v-card>
                      </v-col>
                      <v-spacer></v-spacer>

                      <ClientEditAddress @clientAddress="handleClientAddress" @close="edit.address = false" :change_dialog="edit.address" ></ClientEditAddress>
                      <v-col cols='12' class="d-flex pb-0">
                        <h3 > Endereço de faturamento</h3>
                        <v-spacer></v-spacer>
                        <f-btn v-if="user_allowed || isClerk" edit small class="ml-2" @click="edit.address = true"></f-btn>
                      </v-col>
                      <v-col cols="12" v-if="client?.data?.attributes?.address?.data.length > 0">
                        <AddressForm :address="client?.data?.attributes?.address?.data?.[0]?.attributes" read_only></AddressForm>
                      </v-col>
                      <v-col cols='12'>
                        <v-divider></v-divider>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-domain</v-icon>
                  Obras
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <ShowClientBuildings :client_id="client?.data?.attributes?.id"></ShowClientBuildings>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel  class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-account-box</v-icon>
                  Contato
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <f-btn edit v-if="user_allowed || isClerk" small class="ml-2" @click="edit.contacts = true"></f-btn>
                  </v-card-title>
                  <v-card-text>
                    <client-edit-contacts @update="handleUpdate" @close="edit.contacts = false" :change_dialog="edit.contacts"></client-edit-contacts>
                    <v-row justify="space-around">
                      <template v-if="client.data.attributes.contacts != null">
                        <template v-for="(con, index) in client.data?.attributes?.contacts?.data">
                          <v-container grid-list-lg :key="`con${index}`">
                            <v-row justify="space-around">
                              <v-col cols="12">
                                <ContactForm :contact="con.attributes" read_only includes_employee></ContactForm>
                              </v-col>
                              <v-col cols='12'>
                                <v-divider></v-divider>
                              </v-col>
                            </v-row>
                          </v-container>
                        </template>
                      </template>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            
            <v-expansion-panel  class="border-white" ripple v-if="client.data.attributes.attachment">
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-paperclip</v-icon>
                  Anexo
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row justify="space-around">
                      <template v-if="client.data.attributes.account.data != null">
                        <v-container grid-list-lg>
                          <iframe v-if="client.data.attributes.attachment.kind.includes('pdf') && !isMobile"
                            width="500" height="600" :src="client.data.attributes.attachment.url"></iframe>
                          <v-img v-if="client.data.attributes.attachment.kind.includes('ima')"
                            :src="client.data.attributes.attachment.url" contain></v-img>
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>{{ client.fileSPC.name }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-container>
                      </template>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel class="border-white" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-bell-outline</v-icon>
                  Lembrete de Pagamento (Email e WhatsApp)
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ClientPaymentReminderPreference 
                  :client="client" 
                  @updated="handleSuccessSaved"
                ></ClientPaymentReminderPreference>
              </v-expansion-panel-content>
            </v-expansion-panel>
            
            <v-expansion-panel  class="border-white mb-1" >
              <v-expansion-panel-header class="red--text font-weight-bold">
                <div>
                  <v-icon size="19" color="red">mdi-comment</v-icon>
                  Comentários
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-title class="d-flex align-center justify-end">
                    <client-edit-comment-dialog v-if="can_use_comment"></client-edit-comment-dialog>
                  </v-card-title>
                  <v-card-text>
                    <v-textarea v-if="client.data.attributes.comment" 
                      label="Comentário" :value="client.data.attributes.comment"
                      readonly>
                    </v-textarea>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </v-container>

        <v-container v-if="!loading.client && !only_client_infos" fluid >
          <v-tabs v-model="financial_tabs" color="white" slider-color="primary" light grow  >
            <v-tab ripple v-if="!only_client_infos" :class="[[financial_tabs == 0 ? 'primary--text' : ''],['ma-0 pa-0']]">
              <v-icon left small :color="financial_tabs == 0 ? 'primary' : ''">{{ 'mdi-currency-usd'}}</v-icon>
              Extrato
            </v-tab>
            <v-tab ripple v-if="!only_client_infos" :class="[[financial_tabs == 1 ? 'primary--text' : ''],['ma-0 pa-0']]">
              <v-icon left small :color="financial_tabs == 1 ? 'primary' : ''">{{ 'mdi-handshake'}}</v-icon>
              Faturas
            </v-tab>
            <v-tab ripple v-if="!only_client_infos" :class="[[financial_tabs == 2 ? 'primary--text' : ''],['ma-0 pa-0']]">
              <v-icon left small :color="financial_tabs == 2 ? 'primary' : ''">{{ 'mdi-cart-check'}}</v-icon>
              Pedidos
            </v-tab>
            <v-tab ripple v-if="!only_client_infos" :class="[[financial_tabs == 3 ? 'primary--text' : ''],['ma-0 pa-0']]">
              <v-icon left small :color="financial_tabs == 2 ? 'primary' : ''">{{ 'mdi-credit-card-check'}}</v-icon>
              Limite de Crédito
            </v-tab>
            <v-tabs-items v-model="financial_tabs">
              <v-tab-item :value="0" >
                <div style="border: solid 1px lightgrey; border-radius: 12px;" class="mt-2">
                  <ClientProfileFinancial :client_id="Number(client.data.id)"></ClientProfileFinancial>
                </div>
              </v-tab-item>
              <v-tab-item :value="1" >
                <div style="border: solid 1px lightgrey; border-radius: 12px;" class="mt-2">
                  <ClientProfileAllVrtTransactions 
                    :client_name="client.data.attributes.name || client.data.attributes.corporateName || client.data.attributes.fantasyName" 
                  ></ClientProfileAllVrtTransactions>
                </div>
              </v-tab-item>
              <v-tab-item :value="2" >
                <div style="border: solid 1px lightgrey; border-radius: 12px;" class="mt-2">
                  <ClientProfileOrderHistory
                    :client_name="client.data.attributes.name || client.data.attributes.corporateName || client.data.attributes.fantasyName" 
                  ></ClientProfileOrderHistory>
                </div>
              </v-tab-item>
              <v-tab-item :value="3" >
                <div style="border: solid 1px lightgrey; border-radius: 12px;" class="mt-2">
                  <ClientCredit
                    :client="client"
                    @updateCredit="handleUpdateCredit"
                    @updateScore="handleUpdateScore"
                    @credit_updated="handleSuccessSaved"
                    @successSaved="handleSuccessSaved"
                  ></ClientCredit>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-container>
      </template>
      <template slot="actions">
        <f-btn close @click="goBack()"></f-btn>
      </template>
    </default-dialog> 
    <dialog-loading loadingText="Salvando..." v-if="loading.saving"></dialog-loading>
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import map_mixin from "@/mixins/map"
import Api from '@/api/index';
import { labelFromSicoobKey } from '@/_backoffice/_financial/mixins/sicoob_credentials'


export default {
  name:"ShowClient",
  mixins:[ map_mixin ],
  components: {
    AddressForm:() => import("@/_backoffice/_registrations/components/shared/forms/AddressForm.vue"),
    ContactForm:() => import("@/_backoffice/_registrations/components/shared/forms/ContactForm.vue"),
    ShowClientBuildings: ()=> import("@/_backoffice/_registrations/components/buildings/client/ShowClientBuildings.vue"),
    ClientProfileFinancial: () => import('./ClientProfileFinancial.vue'),
    ClientCommerce: () => import('./ClientProfileCommerce.vue'),
    ClientEditCommentDialog: () => import('./edit/ClientEditCommentDialog.vue'),
    EditSolutions: () => import("@/_backoffice/_registrations/components/shared/EditSolutions.vue"),
    ClientEditInfoDialog: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientEditInfoDialog.vue"),
    ClientEditClientCredit: () => import("./edit/ClientEditClientCreditDialog.vue"),
    ClientEditAddress: () => import("./edit/ClientEditAddressDialog.vue"),
    ClientEditContacts: () => import("./edit/ClientEditContactsDialog.vue"),
    ClientInfoForm:() => import("@/_backoffice/_registrations/components/client/register/forms/ClientInfoForm.vue"),
    ClientEditClientCompanyKey:() => import("@/_backoffice/_registrations/components/client/show/edit/ClientEditClientCompanyKey.vue"),
    ClientDefaultPayment: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientDefaultPayment.vue"),
    ClientAllowedPayments: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientAllowedPayments.vue"),
    ChooseClientPortfolioForm: () => import("@/_backoffice/_registrations/components/shared/client_portfolio/ChooseClientPortfolioForm.vue"),
    DialogEditClientPortfolio: () => import("@/_backoffice/_registrations/components/client/register/DialogEditClientPortfolio.vue"),
    ClientProfileAllVrtTransactions: () => import('./financial/ClientProfileAllVrtTransactions.vue'),
    ClientProfileOrderHistory: () => import('./financial/ClientProfileOrderHistory.vue'),
    ClientCredit: () => import("@/_backoffice/_registrations/components/client/show/financial/ClientCredit.vue"),
    ClientPaymentReminderPreference: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientPaymentReminderPreference.vue"),
    
  },
  data() {
    return {
      only_client_infos: true,
      client_tab: 0,
      financial_tabs: 0,
      client:{ data: { attributes:{ 
        type: null,
        modality_ids:[],
      } }},
      panel: [0, 1],

      clientInfo: {},
      update_actions_map:{
        'normal': "update",
        'basic': "basicUpdate",
        'credit': 'updateCredit',
        'address': 'updateAddress',
        'info': 'updateInfo',
        'account': 'updateAccount',
        'contacts': 'updateContact',
        'seller': 'updateSeller',
      },
      categories: {
        map: {
          not_classified: 'Não classificado',
          resale: 'Revenda',
          construction: 'Construtora',
          industry: 'Indústria de blocos e artefatos',
          final_costumer: 'Consumidor Final',
        }
      },
      headers: [
        { text: 'Vencimento', align: 'center', value: 'attributes.DateExpired' },
        { text: 'Pedido', align: 'center', value: 'attributes.order_number' },
        { text: 'Vendedor', align: 'center', value: 'attributes.seller' },
        { text: 'Valor (R$)', align: 'center', value: 'attributes.ammount' },
        { text: 'Status', align: 'center', value: 'attributes.status_name' },
      ],
      headers_payed: [
        { text: 'Vencimento', align: 'center', value: 'attributes.DateExpired' },
        { text: 'Pedido', align: 'center', value: 'attributes.order_number' },
        { text: 'Vendedor', align: 'center', value: 'attributes.seller' },
        { text: 'Valor (R$)', align: 'center', value: 'attributes.ammount' },
      ],
      edit:{
        info: false,
        contacts: false,
        account: false,
        seller: false,
        client_credit: false,
        address: false,
        spc_and_keys: false,
      },
      loading:{
        client: true,
        saving: false,
      },
      pix_companies: [],
    }
  },
  methods: {
    pixCompanyLabel(key){
      if (!key) return ''

      const company = this.pix_companies.find(
        (c) => c.attributes?.gateway_key === key
      )
      return company?.attributes?.name || labelFromSicoobKey(key) || ''
    },
    getPixCompanies(){
      Api.Company.index({ short: true, only_with_credentials: true })
        .then((r) => r.data)
        .then((res) => {
          this.pix_companies = [...(res.data || [])]
        })
        .catch(() => {
          this.pix_companies = []
        })
    },
    handleClientAddress(){
      this.edit.address = false;
      this.getData();
    },
    handleUpdateCredit(data){
      this.clientInfo = {...data.new_client}
      this.startUpdateClient('credit', this.clientInfo)
    },
    handleUpdateScore(data){
      this.clientInfo = {...data.new_client}
      this.startUpdateClient('basic', this.clientInfo)
    },
    handleSuccessSaved(){
      this.getData()
    },
    handleNewFileUrl(data){
      this.client.data.attributes.attached_file_url = data.url
      // this.$emit('changeAttachedFile', data.url)
    },
    handleChangeAttachedFile(url){
      // this.client.data.attributes.attached_file_url = url
    },
    getData(){
      let id = this.$route.params.id
      this.getClient(id)
    },
    getClient(id){
      this.loading.client = true
      Api.Client.show({id}).then(res => res.data)
      .then(client => {
        this.client = {...client}
        this.setClient({...client})
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(()=>{
        this.loading.client = false
      })
    },
    handleUpdate(options){
      this.clientInfo = {...options.new_client}
      this.startUpdateClient(options.model, this.clientInfo)
    },  
  
    startUpdateClient(kind, client) {
      this.swallConfirmation({
        title: 'Deseja atualizar informações do cliente?',
        icon: 'question',
      }).then( confirmed =>{
        if (confirmed ) {
          this.loading.saving = true
          Api.Client[ this.update_actions_map[kind] ](client, client.id || this.$route.params.id).then(()=>{
            this.clearAndGetData()
            this.addNotification({type: 'success',  msg: `Cliente atualizado com sucesso`})
          }).catch(er => {
            this.addNotification({type: 'error',  msg: `Não foi possível atualizar o cliente.`})
            console.log({er})
          }).finally(()=>{
            this.loading.saving = false
          })
        }
      })
    },
    clearAndGetData(){
      this.closeDialogs()
      this.getData()
    },
    closeDialogs(){
      this.edit = {
        info: false,
        contacts: false,
        account: false,
        seller: false,
        client_credit: false,
        address: false,
        spc_and_keys: false,
      }
    },
    goBack(){
      this.$router.push({ name: "ClientList" })
    },
    ...mapActions({
      getBanks: 'Bank/index',
      setClient: 'Client/setClient',
      getStatuses: 'Status/index'
    })
  },
  computed: {
    canBlock() {
      return this.isSalesExecutive() || this.isDirector()
    },
    isMobile() {
      if (document.body.clientWidth < 700 && (this.client?.data.attributes.document ))
        return true
      else
        return false
    },
    user_allowed() {
      return this.isManager() || this.isDirector() || this.isFinancial() || this.isAnalyst() || this.isSalesExecutive() || this.isCreditAnalyst() || this.isSeller()
    },
    can_use_comment() {
      return this.has_roles(['Manager', 'Director', 'Financial', 'Seller', 'Clerk', 'CreditAnalyst'])
    },
    ...mapState({
      profile: state => state.User.oneUser,
      allStatuses: state => state.Status.allStatuses,
      allBanks: state => state.Bank.allBanks,
    })
  },
  mounted(){
    this.getData()
    this.getPixCompanies()
    this.getStatuses()
  },
}
</script>

<style scoped>
  h3 {
    -webkit-text-fill-color: red !important;
    color: red !important;
  }
  .bcom-red:hover {
    -webkit-text-fill-color: red !important;
  }

  .bcom-green:hover {
    -webkit-text-fill-color: limegreen !important;
  }
  .border-white {
    border-bottom: solid #ddd 1px;
  }
  .bcom-yellow:hover {
    -webkit-text-fill-color: #673AB7 !important;
  }
</style>
